/* AUTOMATED TIME, site scripts */

// touch swipe helper: cb(+1) on swipe left, cb(-1) on swipe right
function atSwipe(el, cb) {
  if (!el) return;
  var x0 = null;
  el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  el.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) cb(dx < 0 ? 1 : -1);
    x0 = null;
  }, { passive: true });
}

// keep the footer below the fold: if the page content is shorter than the
// viewport, add breathing room so the green only appears when you scroll
window.addEventListener('load', function () {
  var f = document.querySelector('footer');
  if (!f) return;
  var gap = window.innerHeight - f.getBoundingClientRect().top;
  if (gap > 0 && window.scrollY === 0) {
    var s = document.createElement('div');
    s.style.height = (gap + 24) + 'px';
    f.parentNode.insertBefore(s, f);
  }
});

// mobile nav, slide-in panel from the left
(function () {
  var nav = document.querySelector('nav.main-nav');
  if (!nav) return;
  // inject close button + instagram link for the mobile panel
  if (!nav.querySelector('.nav-close')) {
    var c = document.createElement('button');
    c.className = 'nav-close';
    c.setAttribute('aria-label', 'Close menu');
    c.innerHTML = '×';
    nav.prepend(c);
    c.addEventListener('click', close);
    var soc = document.createElement('div');
    soc.className = 'nav-social';
    soc.innerHTML = '<a href="https://www.instagram.com/automated_time" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><rect x="3.2" y="3.2" width="17.6" height="17.6" rx="4.6"/><circle cx="12" cy="12" r="4.2"/><circle cx="17.3" cy="6.7" r="0.9" fill="currentColor" stroke="none"/></svg></a>'+
      '<a href="https://wa.me/32472554016" target="_blank" rel="noopener" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.4a8.6 8.6 0 0 0-7.4 12.9L3.4 20.6l4.4-1.1A8.6 8.6 0 1 0 12 3.4z"/><path d="M9.1 8.2c-.3 0-.6.1-.8.4-.9 1-.6 2.6.5 4.1 1.1 1.5 2.8 2.7 4.4 2.9 1 .1 1.8-.2 2.1-1 .1-.4.1-.7-.1-.9l-1.4-.9c-.3-.2-.6-.1-.8.1l-.5.5c-.6-.2-1.9-1.1-2.4-2.1l.4-.6c.2-.2.2-.6 0-.8l-.9-1.3c-.1-.2-.3-.4-.5-.4z"/></svg></a>';
    nav.appendChild(soc);
  }
  function open() { nav.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close() { nav.classList.remove('open'); document.body.style.overflow = ''; }
  document.querySelectorAll('.nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      nav.classList.contains('open') ? close() : open();
    });
  });
  nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

// mini galleries (timeline sliders): arrows + optional auto-rotate
document.querySelectorAll('.mini-gal').forEach(function (gal) {
  var imgs = Array.prototype.slice.call(gal.querySelectorAll('.in img'));
  if (imgs.length < 2) return;
  var cur = 0, timer = null;
  function show(i) {
    cur = (i + imgs.length) % imgs.length;
    imgs.forEach(function (im, j) { im.classList.toggle('active', j === cur); });
  }
  function restart() {
    var ms = parseInt(gal.getAttribute('data-auto') || '0', 10);
    if (!ms) return;
    clearInterval(timer);
    timer = setInterval(function () { show(cur + 1); }, ms);
  }
  gal.querySelector('.gal-btn.prev').addEventListener('click', function () { show(cur - 1); restart(); });
  gal.querySelector('.gal-btn.next').addEventListener('click', function () { show(cur + 1); restart(); });
  atSwipe(gal, function (d) { show(cur + d); restart(); });
  show(0); restart();
});

// catalog: brand filter + search + price sort (watches & accessories)
(function () {
  var grid = document.querySelector('.grid.products');
  var filterWrap = document.querySelector('[data-filters]');
  var search = document.getElementById('cat-search');
  var sort = document.getElementById('cat-sort');
  if (!grid || (!filterWrap && !search && !sort)) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
  var original = cards.slice();
  var state = { brand: 'all', q: '' };
  function apply() {
    cards.forEach(function (c) {
      var okBrand = state.brand === 'all' || c.getAttribute('data-brand') === state.brand;
      var okQuery = !state.q || c.textContent.toLowerCase().indexOf(state.q) !== -1;
      c.style.display = (okBrand && okQuery) ? '' : 'none';
    });
  }
  if (filterWrap) {
    filterWrap.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      filterWrap.querySelectorAll('button').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      state.brand = b.getAttribute('data-filter');
      apply();
    });
  }
  if (search) {
    search.addEventListener('input', function () {
      state.q = search.value.trim().toLowerCase();
      apply();
    });
  }
  if (sort) {
    sort.addEventListener('change', function () {
      var v = sort.value, order;
      if (v === 'default') {
        order = original;
      } else {
        order = cards.slice().sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-price') || '0');
          var pb = parseFloat(b.getAttribute('data-price') || '0');
          return v === 'asc' ? pa - pb : pb - pa;
        });
      }
      order.forEach(function (c) { grid.appendChild(c); });
    });
  }
})();

// watch detail modal
(function () {
  var modal = document.getElementById('watch-modal');
  if (!modal) return;
  var mPhoto = modal.querySelector('.m-photo img');
  var mBrand = modal.querySelector('.m-body .brand');
  var mName = modal.querySelector('.m-body h3');
  var mPrice = modal.querySelector('.m-body .price');
  var mDesc = modal.querySelector('.m-body p');
  var mMail = modal.querySelector('.m-body a.btn');
  document.querySelectorAll('.card[data-brand]').forEach(function (card) {
    card.querySelector('.btn').addEventListener('click', function (e) {
      e.preventDefault();
      mPhoto.src = card.querySelector('.photo img').src;
      mBrand.textContent = card.querySelector('.brand').textContent;
      mName.textContent = card.querySelector('.name').textContent;
      mPrice.textContent = card.querySelector('.price').textContent;
      mDesc.textContent = card.getAttribute('data-desc') || '';
      mMail.href = 'mailto:info@automatedtime.be?subject=' +
        encodeURIComponent('Enquiry, ' + card.querySelector('.name').textContent);
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  });
  function close() { modal.classList.remove('open'); document.body.style.overflow = ''; }
  modal.querySelector('.close').addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

// watch roll personaliser
(function () {
  var input = document.getElementById('roll-input');
  if (!input) return;
  var out = document.getElementById('emboss-out');
  var count = document.getElementById('roll-count');
  var allowed = /[^A-Z0-9.# ]/g;
  function maxTweeKeer(v) {
    // elk teken hoogstens twee keer; spaties zijn vrij te gebruiken
    var telling = {}, uit = '';
    for (var i = 0; i < v.length; i++) {
      var c = v[i];
      if (c === ' ') { uit += c; continue; }
      telling[c] = (telling[c] || 0) + 1;
      if (telling[c] <= 2) uit += c;
    }
    return uit;
  }
  function pasGrootte() {
    // krimp het lettertype tot de tekst op de leren band past
    out.style.fontSize = '';
    for (var i = 0; i < 6 && out.scrollWidth > out.clientWidth; i++) {
      var basis = parseFloat(getComputedStyle(out).fontSize);
      var nieuw = Math.max(12, basis * out.clientWidth / out.scrollWidth * 0.97);
      out.style.fontSize = nieuw + 'px';
      if (nieuw <= 12) break;
    }
  }
  function update() {
    var v = maxTweeKeer(input.value.toUpperCase().replace(allowed, ''));
    input.value = v;
    out.textContent = v || 'NIELS';
    out.style.opacity = v ? 1 : 0.45;
    pasGrootte();
    count.textContent = v.length + ' ' + (v.length === 1 ? (count.dataset.one || 'character') : (count.dataset.many || 'characters'));
  }
  input.addEventListener('input', update);
  update();

  // roll photo gallery (arrows + clickable thumbs)
  var rollImgEl = document.getElementById('roll-photo');
  var thumbWrap = document.getElementById('roll-thumbs');
  if (rollImgEl && thumbWrap) {
    var thumbFrames = Array.prototype.slice.call(thumbWrap.querySelectorAll('.photo-frame'));
    // the gallery includes the opening photo (NIELS roll) as first image
    var gallery = [rollImgEl.src].concat(thumbFrames.map(function (f) { return f.querySelector('img').src; }));
    var galCur = 0;
    function galShow(i) {
      galCur = (i + gallery.length) % gallery.length;
      rollImgEl.src = gallery[galCur];
      thumbFrames.forEach(function (f, j) { f.classList.toggle('active', j + 1 === galCur); });
    }
    thumbFrames.forEach(function (f, i) {
      f.addEventListener('click', function () { galShow(i + 1); });
    });
    document.getElementById('roll-prev').addEventListener('click', function () { galShow(galCur - 1); });
    document.getElementById('roll-next').addEventListener('click', function () { galShow(galCur + 1); });
    atSwipe(rollImgEl.closest('.gal'), function (d) { galShow(galCur + d); });
  }

  // roll type picker
  var picker = document.querySelectorAll('.roll-picker button');
  var price = document.getElementById('roll-price');
  var rollImg = document.getElementById('roll-photo');
  picker.forEach(function (b) {
    b.addEventListener('click', function () {
      picker.forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      if (price) price.textContent = b.getAttribute('data-price');
      if (rollImg) rollImg.src = b.getAttribute('data-img');
    });
  });

  // order button → WhatsApp with roll type and personalisation prefilled
  var order = document.getElementById('roll-order');
  order.addEventListener('click', function (e) {
    e.preventDefault();
    var btn = document.querySelector('.roll-picker button.active');
    var type = btn.getAttribute('data-name') || btn.textContent.trim();
    var chars = input.value || (order.dataset.none || '(no personalisation)');
    var sjabloon = order.dataset.wa || 'Hi! I would like to order the {type}, embossed with: {chars}.';
    window.open('https://wa.me/32472554016?text=' +
      encodeURIComponent(sjabloon.replace('{type}', type).replace('{chars}', chars)),
      '_blank', 'noopener');
  });
})();

// forms → playful "sent successfully" state (ladder + flag, like the app design)
document.querySelectorAll('form.at-form').forEach(function (form) {
  if (form.classList.contains('native-form')) return; // Shopify verstuurt deze zelf
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var data = new FormData(form);
    var lines = [];
    data.forEach(function (v, k) { if (v) lines.push(k + ': ' + v); });
    var subject = form.getAttribute('data-subject') || 'Website enquiry';
    // open the visitor's mail client with the composed message
    window.location.href = 'mailto:info@automatedtime.be?subject=' +
      encodeURIComponent(subject) + '&body=' + encodeURIComponent(lines.join('\n'));
    form.style.display = 'none';
    var s = form.parentElement.querySelector('.form-success');
    if (s) s.style.display = 'block';
  });
});

/* ---- reviews carousel ---- */
(function(){
  var wrap=document.querySelector('.rev-carousel');
  if(!wrap)return;
  var track=wrap.querySelector('.grid');
  var cards=[].slice.call(track.children);
  var page=0;
  function per(){return window.innerWidth<=760?1:3}
  function pages(){return Math.ceil(cards.length/per())}
  function render(){
    var p=per();
    cards.forEach(function(c,i){c.style.display=(Math.floor(i/p)===page)?'':'none'});
  }
  function go(d){
    page=(page+d+pages())%pages();
    track.style.opacity=0;
    setTimeout(function(){render();track.style.opacity=1},170);
  }
  wrap.querySelector('.rev-btn.prev').addEventListener('click',function(){go(-1)});
  wrap.querySelector('.rev-btn.next').addEventListener('click',function(){go(1)});
  function equalize(){
    cards.forEach(function(c){c.style.display='';c.style.minHeight=''});
    var h=0;
    cards.forEach(function(c){h=Math.max(h,c.offsetHeight)});
    cards.forEach(function(c){c.style.minHeight=h+'px'});
  }
  window.addEventListener('resize',function(){if(page>=pages())page=0;equalize();render()});
  window.addEventListener('load',function(){equalize();render()});
  track.style.transition='opacity .17s';
  equalize();
  render();
})();

/* ---- roll gallery fit: laat de linkerkolom eindigen op de hoogte van het formulier ---- */
(function(){
  var wrap=document.querySelector('.roll-config'); if(!wrap)return;
  var left=wrap.children[0], right=wrap.querySelector('.roll-form');
  if(!left||!right||left===right)return;
  function fit(){
    if(window.innerWidth<=1020){left.style.maxWidth='';return;}
    left.style.maxWidth='';
    for(var i=0;i<3;i++){
      var lh=left.offsetHeight, rh=right.offsetHeight;
      if(Math.abs(lh-rh)<8)break;
      var w=left.offsetWidth*rh/lh;
      left.style.maxWidth=Math.max(360,Math.round(w))+'px';
    }
  }
  window.addEventListener('load',fit);
  window.addEventListener('resize',fit);
  wrap.querySelectorAll('img').forEach(function(im){im.addEventListener('load',fit);});
  fit();
})();

/* ---- brand dropdown (mobiel) ---- */
(function(){
  var wrap=document.querySelector('[data-filters]');
  var bar=document.querySelector('.catalog-bar');
  if(!wrap||!bar||bar.querySelector('.brand-select'))return;
  var sel=document.createElement('select');
  sel.className='brand-select';
  sel.setAttribute('aria-label','Brand');
  [].forEach.call(wrap.querySelectorAll('button'),function(b){
    var o=document.createElement('option');
    o.value=b.getAttribute('data-filter');
    o.textContent=(o.value==='all')?'All brands':b.textContent;
    sel.appendChild(o);
  });
  sel.addEventListener('change',function(){
    var b=wrap.querySelector('button[data-filter="'+sel.value+'"]');
    if(b)b.click();
  });
  var sort=bar.querySelector('#cat-sort');
  if(sort)bar.insertBefore(sel,sort);else bar.appendChild(sel);
})();

/* ---- topbalk (alle schermen): verbergen bij omlaag scrollen, tonen bij omhoog ---- */
(function(){
  var bar=document.querySelector('.hf-nav'); if(!bar)return;
  var html=document.documentElement;
  if(document.querySelector('.hero-full'))html.classList.add('has-hero');
  var lastY=window.scrollY;
  function tick(){
    var y=window.scrollY;
    var drempel=html.classList.contains('has-hero')?10:160;
    var menuOpen=document.querySelector('nav.main-nav.open');
    if(!menuOpen){
      /* op hero-pagina's verdwijnt de balk meteen bij omlaag scrollen,
         zodat hij nooit doorzichtig over de hero schuift; omhoog tonen */
      if(y>lastY+8&&y>drempel)html.classList.add('bar-hidden');
      else if(y<lastY-8||y<=drempel)html.classList.remove('bar-hidden');
    }
    if(html.classList.contains('has-hero')){
      /* alleen in rust bovenaan is de balk doorzichtig; zodra er
         gescrold is komt hij altijd als dichte cremebalk terug */
      html.classList.toggle('bar-solid',y>drempel);
    }else{
      html.classList.add('bar-solid');
    }
    lastY=y;
  }
  window.addEventListener('scroll',tick,{passive:true});
  window.addEventListener('resize',tick);
  tick();
})();

/* ---- grote schermen: zachte proportionele schaal (max 1.32x), header en hero uitgezonderd ---- */
(function(){
  var BASE=1440,MAX=1.32;
  function apply(){
    var w=window.innerWidth;
    var z=w>BASE?Math.min(w/BASE,MAX):1;
    [].slice.call(document.body.children).forEach(function(el){
      if(el.tagName==='SCRIPT')return;
      if(el.classList.contains('hero-full'))return;
      if(el.classList.contains('hf-nav'))return;
      el.style.zoom=(z===1?'':z);
    });
  }
  window.addEventListener('resize',apply);
  apply();
})();
